import { Instance } from 'mobx-state-tree';
import { DeleteCustomerProfilesResultDtoModelBase } from './DeleteCustomerProfilesResultDtoModel.base';

/* The TypeScript type of an instance of DeleteCustomerProfilesResultDtoModel */
export interface DeleteCustomerProfilesResultDtoModelType extends Instance<typeof DeleteCustomerProfilesResultDtoModel.Type> {}

/* A graphql query fragment builders for DeleteCustomerProfilesResultDtoModel */
export { selectFromDeleteCustomerProfilesResultDto, deleteCustomerProfilesResultDtoModelPrimitives, DeleteCustomerProfilesResultDtoModelSelector } from './DeleteCustomerProfilesResultDtoModel.base';

/**
 * DeleteCustomerProfilesResultDtoModel
 */
export const DeleteCustomerProfilesResultDtoModel = DeleteCustomerProfilesResultDtoModelBase;
